import { CCCLinkList, LinkListItem } from "../components/link-list/index";
import { CCCPanel } from "../components/panel/panel";
// Import utils

import { getDomElement } from "../core/utilities";
import { VanillaPagesType } from "../core/types/VanillaPages";
import OContentModel from "../models/OContentModel";

//Import providers
import Event from "../core/interfaces/Event";
import VanillaEventsProvider from "../core/providers/community/vanillaProviders/VanillaEventsProvider";
import { UpcomingEventsConfiguration } from "../core/types/UpcomingEventsConfigurations";

export default class UpcomingEventListController {
  private $anchor: HTMLElement = null;
  private configsForCategory: UpcomingEventsConfiguration;
  private upcomingEvents: Array<Event> = [];
  private anchorID = "#CCCUpcomingEvents";
  private currentCategory = "";

  init(type: VanillaPagesType, categoryName: string): void {
    console.info(`Init upcoming events for category - ${categoryName}`);
    this.currentCategory = categoryName;
    switch (type) {
      case VanillaPagesType.discussions:
        console.info("Disc page - Upcoming Events");
        this._initUpcomingEvents();
        break;
      case VanillaPagesType.categories:
        console.info("Cats page - Upcoming Events");
        this._initUpcomingEvents();
        break;
      default:
        console.error(`Upcoming events - ${type} page type is not supported`);
        break;
    }
  }

  private async _initUpcomingEvents(): Promise<boolean> {
    try {
      this.$anchor = <HTMLElement>getDomElement(this.anchorID);
      if (this.$anchor) {
        this.configsForCategory =
          await OContentModel.getUpcomingEventsConfigurationsForCategory(
            this.currentCategory
          );
        this._loadPanel();
      } else {
        throw `Announcements Panel - ${this.$anchor} element not found in DOM`;
      }
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  private async _loadPanel(): Promise<void> {
    const provider = new VanillaEventsProvider();
    const current_date = new Date();
    const end_date = new Date(current_date.getFullYear() + 1, 11, 31);
    this.upcomingEvents = await provider.getUpcomingEvents(
      current_date.toDateString(),
      end_date.toDateString(),
      this.configsForCategory.category_id
    );
    if (
      this.configsForCategory &&
      this.configsForCategory.is_active === "Y" &&
      this.upcomingEvents.length >= 1
    ) {
      this._buildEventsPanel();
    } else {
      this.$anchor.remove();
      console.warn(`No events where found, skipping Upcoming Events panel...`);
    }
  }

  private _buildEventsPanel(): void {
    const $cccPanel: CCCPanel = <CCCPanel>document.createElement("ccc-panel");
    try {
      $cccPanel.setAttribute("title", "Upcoming Events");
      const $cccLinkList: CCCLinkList = <CCCLinkList>(
        document.createElement("ccc-link-list")
      );
      $cccLinkList.setAttribute("slot", "component");
      $cccPanel.append($cccLinkList);
      this.$anchor.append($cccPanel);
      const upcomingEventsList: Array<LinkListItem> = [];
      this.upcomingEvents.forEach((upcomingEvent) => {
        const parsedStartDate = `${upcomingEvent.dateStart.getDate()}-${upcomingEvent.dateStart.toLocaleString(
          "default",
          { month: "long" }
        )}-${upcomingEvent.dateStart.getFullYear()}`;
        const itemTitle = `${upcomingEvent.name} - ${parsedStartDate}`;
        const listItem: LinkListItem = {
          text: itemTitle,
          href: upcomingEvent.url,
        };
        upcomingEventsList.push(listItem);
      });
      console.debug("Upcoming Events Panel- UE:", upcomingEventsList);
      $cccLinkList.setState({
        title: "",
        links: upcomingEventsList,
        moreLink: this.configsForCategory.general_events_url,
      });
      $cccLinkList.loading = false;
    } catch (err) {
      console.error(err);
      $cccPanel.hide();
    }
  }
}
